import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Orders from '@/pages/Orders.vue'
import OrderDetails from '@/pages/OrderDetails.vue'
import DishCategories from '@/pages/DishCategories.vue'
import Dishes from '@/pages/Dishes.vue'
import Help from '@/pages/Help.vue'
import Settings from '@/pages/Settings.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'CurrentOrders',
    component: Orders,
    props: {
      status: [1, 2]
    },
    meta: {
      title: "Bestellungen"
    }
  }, {
    path: '/orderDetails/:id',
    name: 'OrderDetails',
    component: OrderDetails,
    props: true,
    meta: {
      title: "Bestelldetails"
    }
  }, {
    path: '/dishCategories',
    name: 'DishCategories',
    component: DishCategories,
    meta: {
      title: "Verfügbare Menüs"
    }
  }, {
    path: '/dishes/:categoryId',
    name: 'Dishes',
    component: Dishes,
    props: true,
    meta: {
      title: "Verfügbare Menüs"
    }
  }, {
    path: '/pastOrders',
    name: 'PastOrders',
    component: Orders,
    props: {
      status: [3, 4],
    },
    meta: {
      title: "Letzte Bestellungen"
    }
  }, {
    path: '/help',
    name: 'Help',
    component: Help,
    meta: {
      title: "Hilfe"
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      title: "Einstellungen"
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
